import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(password: string, confirmPassword: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const passwordControl = control.get(password);
    const confirmPasswordControl = control.get(confirmPassword);

    if (!passwordControl || !confirmPasswordControl) {
      return null; // No controls found.
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      return { passwordMismatch: true }; // Passwords do not match.
    }

    return null; // Passwords match.
  };
}
